/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-nutrition-plan.reducer';

export const PatientNutritionPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientNutritionPlanEntity = useAppSelector(state => state.patientNutritionPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientNutritionPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.detail.title">PatientNutritionPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.endDate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientNutritionPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{patientNutritionPlanEntity.glucoUser ? patientNutritionPlanEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientNutritionPlan.nutritionPlan">Nutrition Plan</Translate>
          </dt>
          <dd>{patientNutritionPlanEntity.nutritionPlan ? patientNutritionPlanEntity.nutritionPlan.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-nutrition-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-nutrition-plan/${patientNutritionPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientNutritionPlanDetail;
